import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Post from './views/Post.vue'
import Login from './views/Login.vue'
// ---------- Automatic Fueling ----------
import Food from './views/fuel/Food.vue'
import Meal from './views/fuel/Meal.vue'
import Plan from './views/fuel/Plan.vue'
import Fuel from './views/fuel/Fuel.vue'
import Shopping from './views/fuel/Shopping.vue'
import Inventory from './views/fuel/Inventory.vue'
import Book from './views/fuel/Book.vue'
import MealEditor from './views/fuel/MealEditor.vue'
import Log from './views/fuel/Log.vue'

import firebase from 'firebase'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/post/:slug',
      name: 'Post',
      component: Post
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/fuel/',
      name: 'Fuel',
      component: Fuel,
      meta: {
        requiresAdmin: true
      }
    },
    {
      path: '/fuel/food',
      name: 'Food',
      component: Food,
      meta: {
        requiresAdmin: true
      }
    },
    {
      path: '/fuel/meal',
      name: 'Meal',
      component: Meal,
      meta: {
        requiresAdmin: true
      }
    },
    {
      path: '/fuel/meal/:id',
      name: 'MealEditor',
      component: MealEditor,
      meta: {
        requiresAdmin: true
      }
    },
    {
      path: '/fuel/plan',
      name: 'Plan',
      component: Plan,
      meta: {
        requiresAdmin: true
      }
    },
    {
      path: '/fuel/shopping',
      name: 'Shopping',
      component: Shopping,
      meta: {
        requiresAdmin: true
      }
    },
    {
      path: '/fuel/inventory',
      name: 'Inventory',
      component: Inventory,
      meta: {
        requiresAdmin: true
      }
    },
    {
      path: '/fuel/book',
      name: 'Book',
      component: Book,
      meta: {
        requiresAdmin: true
      }
    },
    {
      path: '/fuel/log',
      name: 'Log',
      component: Log,
      meta: {
        requiresAdmin: true
      }
    }
  ]
})

router.beforeEach((to,from,next) => {
  // check to see if the route requires admin
  if( to.matched.some(rec => rec.meta.requiresAdmin) ) {
    // check auth state of user
    let user = firebase.auth().currentUser
    if( user ) {
      // user is signed in, check id
      if( user.uid == "eAYcgkMXw5SHzd8IZJypycYPK1g2" ) {
        // user is an admin, proceed to view
        next()
      } else {
        // user is NOT an admin, log them out and redirect to login
        firebase.auth().signOut().then( () => {
          next({ name: 'Login' })
        })
      }
    } else {
      // user not signed in, redirect to login
      next({ name: 'Login' })
    }
  } else {
    next()
  }
})

export default router
